import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ISidePanelInstance } from '../interfaces';
import { filter } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable({ providedIn: 'root' })
export class OverlaySidePanelRegisterService {
  #sidePanelStack: ISidePanelInstance[] = [];

  constructor(private _router: Router) {
    this._router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntilDestroyed(),
      )
      .subscribe(() =>
        this.#sidePanelStack.forEach((item) => {
          this.dissmis(item);
        }),
      );
  }

  add(sidePanel: ISidePanelInstance) {
    this.#sidePanelStack.push(sidePanel);
  }

  dismissLast(error?: any) {
    const sidePanel = this.#sidePanelStack.pop();
    if (sidePanel) {
      sidePanel.overlay.dispose();
      typeof sidePanel.reject === 'function' ? sidePanel.reject(error) : void 0;
    }
  }

  closeLast(result?: any) {
    if (this.#sidePanelStack.length < 1) {
      return;
    }
    const sidePanel = this.#sidePanelStack[this.#sidePanelStack.length - 1];
    this.close(sidePanel, result);
  }

  private dissmis(sidePanel: ISidePanelInstance, error?: unknown) {
    sidePanel.overlay.dispose();
    typeof sidePanel.reject === 'function' ? sidePanel.reject(error) : void 0;
  }

  private close(sidePanel: ISidePanelInstance, result?: any) {
    if (!sidePanel.onClosePromise) {
      sidePanel.onClosePromise =
        typeof sidePanel.onClose === 'function' ? sidePanel.onClose(result) : Promise.resolve();

      sidePanel.onClosePromise
        .then((onCloseRes) => {
          sidePanel.overlay.dispose();
          typeof sidePanel.resolve === 'function'
            ? sidePanel.resolve({ sidePanelResult: result, onCloseResult: onCloseRes })
            : void 0;
          sidePanel.onClosePromise = undefined;
          this.#sidePanelStack.pop();
        })
        .catch((reason: any) => {
          sidePanel.onClosePromise = undefined;
          if (reason !== 'STOPE_CLOSE_CODE') {
            return Promise.reject(reason);
          }
          return null;
        });
    }
  }
}
